import type { ComponentProps, PropsWithChildren } from 'react';
import { Link } from 'react-router';

type PaginationLinkProps = PropsWithChildren<ComponentProps<typeof Link>>;

export const PaginationLink = ( { children, ...linkProps }: PaginationLinkProps ) => {

  return (
    <Link
      className={ 'size-full flex items-center justify-center' }
      { ...linkProps }>
      { children }
    </Link>
  )
}
PaginationLink.displayName = 'PaginationLink';
